import { Pipe, PipeTransform } from '@angular/core';

type ValueItem = {
  [key: string]: any;
};

@Pipe({
    name: 'errorReader',
    standalone: false
})
export class ErrorReaderPipe implements PipeTransform {
  transform(values: any, ...args: unknown[]): string {
    let lastError = '';
    let lastErrorValue: any;

    const findError = (item: ValueItem) => {
      for (const error in item) {
        lastError = error;
        lastErrorValue = item[error];
      }
    };

    if (Array.isArray(values)) {
      values.forEach(findError);
    } else {
      findError(values);
    }

    const formatError = (lastError: string, lastErrorValue: any): string => {
      const error: { [index: string]: any } = {
        required: '*Campo obrigatório.',
        minlength: `*Mínimo de ${lastErrorValue?.requiredLength} caracteres.`,
        maxlength: `*Máximo de ${lastErrorValue?.requiredLength} caracteres.`,
        min: `*Valor mínimo de ${lastErrorValue?.min} é necessário.`,
        max: `*Valor máximo de ${lastErrorValue?.max} atingido.`,
        matDatepickerParse: '*O formato da data informada é inválido.',
        matDatepickerFilter: '*A data selecionada não corresponde ao filtro definido.',
        matDatepickerMin: '*A data selecionada é antecede a data mínima permitida.',
        matDatepickerMax: '*A data selecionada é excede a data máxima permitida.',
        matStartDateInvalid: '*A data inicial não pode ser posterior à data final.',
        matEndDateInvalid: '*A data final não pode ser anterior à data inicial.',
      };

      if (error[lastError]) {
        return error[lastError];
      } else if (typeof lastErrorValue === 'string') {
        return `*${lastErrorValue}`;
      }
      return `*${lastError.charAt(0).toUpperCase() + lastError.slice(1)}`;
    };

    return formatError(lastError, lastErrorValue);
  }
}
